import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { finalize, first } from 'rxjs';
import { LoadingDefaults } from '../../../shared/models/loading-defaults.model';
import {
  VehicleResponse,
  VehiclesClient,
} from '../../../shared/services/api-client';
import { RplLoadingService } from '../../../shared/services/rpl-loading.service';

export const vehicleResolverFactory = (
  vehicleId: number,
): ResolveFn<VehicleResponse> => {
  return () => {
    const client = inject(VehiclesClient);
    const loadingService = inject(RplLoadingService);
    let loadingId: string | undefined;

    const timeout = setTimeout(() => {
      loadingId = loadingService.start();
    }, LoadingDefaults.StartIndicatorTimeout);

    return client.getVehicleById(vehicleId).pipe(
      first(),
      finalize(() => {
        clearTimeout(timeout);
        loadingService.end(loadingId);
      }),
    );
  };
};
